module.exports = __webpack_public_path__ + "img/logo.87e241d3.svg";